import { useState } from "react";
import DesignService from "@/service/designService";
import { bodyStore } from "@/store/bodyStore";
import { LoadingStore } from "@/store/loadingStore";
import { toastStore } from "@/store/toastStore";
import { PartStyles } from "@/types/design";
import { createClient } from "@/utils/supabase/client";

type DesignSaveDialogArg = {
	bodyId: string | undefined;
};

// 保存ダイアログのためのロジックを提供します
export default function useDesignSaveDialog(arg: DesignSaveDialogArg) {
	const { bodyId } = arg;
	const { body } = bodyStore();
	const { openToast } = toastStore();
	const { setIsLoading } = LoadingStore();

	const [isDialogOpen, setIsDialogOpen] = useState(false);
	const onDialogChange = () => {
		setIsDialogOpen((prev) => !prev);
	};

	const onSaveButtonClick = async () => {
		setIsLoading(true);

		onDialogChange();
		const supabase = createClient();
		const session = await supabase.auth.getSession();
		const accessToken = session.data.session?.access_token;

		const partStyles: PartStyles = body.map((m) => {
			const { partId, partStyle } = m;
			// partId が undefined の場合、partStyle から "id" キーを除外
			const style =
				partId === undefined
					? Object.fromEntries(
							Object.entries(partStyle).filter(
								([key]) => key !== "id",
							),
						)
					: partStyle;
			return {
				id: partId,
				style: style as PartStyles[number]["style"],
			};
		});

		const service = new DesignService(accessToken!);
		const response = bodyId
			? await service.Update({ bodyId, partStyles })
			: await service.Create(partStyles);
		response.when({
			onSuccess: (value) => {
				openToast({
					type: "success",
					title: "保存しました。",
				});
			},
			onFailure: (error) => {
				const status = (error as any)?.response?.status;
				if (error.message === "Unauthorized" || status == 401) {
					openToast({
						type: "warning",
						title: "デザイン保存はログイン後可能です。",
					});
				} else if (
					error.message === "Unprocessable Entity" ||
					status == 422
				) {
					openToast({
						type: "warning",
						title: "保存に失敗しました。",
						description:
							"デザインはユーザーにつき10こまで作成できます。",
					});
				} else {
					openToast({
						type: "error",
						title: "保存に失敗しました。",
						description:
							"もう一度けっていボタンを押して登録してください。",
					});
				}
			},
		});
		setIsLoading(false);
	};

	return { isDialogOpen, onDialogChange, onSaveButtonClick };
}
